angular.module('internal.chargebookings', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider.state('internal.chargebookings', {
            url: '/chargebookings',
            views: {
                'content': {
                    templateUrl: 'js/internal/charge-booking/charge-booking.html',
                    controller: 'ChargeBookingsController'
                }
            }
        });
        $stateProvider.state('internal.chargebooking', {
            url: '/chargebooking/:id/:state',
            views: {
                'content': {
                    templateUrl: 'js/internal/charge-booking/add-charge-booking/add-charge-booking.html',
                    controller: 'AddChargeBookingController'
                }
            }
        });
    }])
    // Charge Bookings
    .controller('ChargeBookingsController', ChargeBookingsController)
    .service('ChargeBookingsService', ChargeBookingsService.$inject.concat(ChargeBookingsService))
    // Add Charge Booking
    .controller('AddChargeBookingController', AddChargeBookingController);
